import { PageEditorShell } from "@/features/page-editor"
import { useMemo } from "react"
import { buildGeneratedArtifactIdentity } from "@/features/preview/provenance/generated-artifact-identity"
import { GeneratedArtifactIdentityChip } from "@/features/preview/provenance/generated-artifact-identity-chip"
import { resolveStudioActiveProjectPlan } from "@/features/project/lib/studio-active-project-plan"
import { useStudioStore } from "@/store/studio-store"

/**
 * Page surface — Layers and Components are tools inside the page workspace.
 */
export function EditorSurface() {
  const currentProject = useStudioStore((state) => state.currentProject)
  const currentProjectId = useStudioStore((state) => state.currentProjectId)
  const projectMeta = useStudioStore((state) => state.projectMeta)
  const projectPlan = useStudioStore((state) => state.projectPlan)
  const projectSettings = useStudioStore((state) => state.projectSettings)
  const projectSource = useStudioStore((state) => state.projectSource)
  const isDirty = useStudioStore((state) => state.isDirty)
  const hasUncommittedArtifactLineage = useStudioStore((state) => state.hasUncommittedArtifactLineage)
  const saveConflict = useStudioStore((state) => state.saveConflict)
  const activeProjectPlan = useMemo(
    () => resolveStudioActiveProjectPlan({
      storePlan: projectPlan,
      projectMeta,
      manifest: currentProject?.manifest,
      projectRecord: currentProject,
    }).plan,
    [currentProject, projectMeta, projectPlan],
  )
  const identity = useMemo(
    () => buildGeneratedArtifactIdentity({
      projectId: currentProjectId,
      projectSource,
      projectMeta,
      projectSettings,
      projectPlan: activeProjectPlan,
      project: currentProject,
      isDirty,
      hasSaveConflict: saveConflict != null,
      hasUncommittedArtifactLineage,
    }),
    [activeProjectPlan, currentProject, currentProjectId, hasUncommittedArtifactLineage, isDirty, projectMeta, projectSettings, projectSource, saveConflict],
  )

  return (
    <div className="relative h-full min-h-0">
      <PageEditorShell embedded inspectorMode="work-panel" />
      <div className="pointer-events-none absolute left-3 top-3 z-40 max-w-[calc(100%-1.5rem)]">
        <GeneratedArtifactIdentityChip identity={identity} className="pointer-events-auto" />
      </div>
    </div>
  )
}
